<template>
    <div class="signature-record">
        <el-table :data="signList" style="width: 100%;" border height="80vh">
             <el-table-column prop="processInstanceName" label="流程名称" align="center"></el-table-column>
            <el-table-column prop="taskName" label="任务名称" align="center"></el-table-column>
            <el-table-column prop="primaryFileName" label="文件名称" align="center"></el-table-column>
            <el-table-column prop="createTime" label="签章时间" align="center"></el-table-column>
            <el-table-column fixed="right" label="原文件操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row,1)"></el-button>
                <el-button type="success" size="mini" icon="el-icon-download" title="下载" circle @click="downloadFile(scope.row,1)"></el-button>
                <el-button type="warning" size="mini" icon="iconfont icon-other-gaizhang" title="盖章" circle @click="sealFile(scope.row)"></el-button>
                <!-- <el-button type="danger" size="mini" icon="el-icon-printer" title="打印" circle @click="printFile(scope.row)"></el-button> -->
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="盖章文件操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row,2)"></el-button>
                <el-button type="success" size="mini" icon="el-icon-download" title="下载" circle @click="downloadFile(scope.row,2)"></el-button>
                <!-- <el-button type="danger" size="mini" icon="el-icon-printer" title="打印" circle @click="printFile(scope.row)"></el-button> -->
              </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { getSignatureFileRecord, downloadFiles, setSignatureRecordParam, getSignatureRecord } from '@/data-model';
    import { getPreviewFileUrl } from '@/utils/grocer';
    import { API_FILE_DOWNLOAD } from '@/common/constants';
    import { signUrl } from '@/common/constants/const-global';
    import { cloneDeep } from 'lodash';
    import { mapGetters } from 'vuex';
    export default {
        data () {
            return {
                signList: [], // 列表数据
                searchKeyWord: '', // 查询的关键字,
                loading: false // 列表的loading状态
            };
        },
        props: {
            filePath: {
                type: String
            }
        },
        computed: {
            ...mapGetters([
                'userInfo'
            ])
        },
        created () {
            this._getFormData();
        },
        methods: {
            async _getFormData () {
                let param = {filePath: this.filePath};
                let res = await getSignatureRecord(param);
                this.signList = res.signList;
            },
            async previewFile (obj, type) {
                // let operationType='&operationType=2';
                let url = ``;
                if (type == 1) { // 源文件
                    url = `${API_FILE_DOWNLOAD}${obj.primaryFilePath}`;
                    obj.fileName = obj.primaryFileName;
                    obj.filePath = obj.primaryFilePath;
                    let index = url.lastIndexOf('.');
                    let fileType = url.substr(index);
                    if (fileType === '.png' || fileType === '.PNG' ||
                        fileType === '.pdf' || fileType === '.PDF' ||
                        fileType === '.JPG' || fileType === '.jpg' ||
                        fileType === '.JPEG' || fileType === '.jpeg' ||
                        fileType === '.BMP' || fileType === '.bmp' ||
                        fileType === '.GIF' || fileType === '.gif' ||
                        fileType === '.TXT' || fileType === '.txt') {
                        let tempwindow = window.open();
                        url = url + '&operationType=2';
                        tempwindow.location = url;
                    } else if (fileType === '.doc' || fileType === '.docx' || fileType === '.xls' || fileType === '.xlsx' || fileType === '.ppt' || fileType === '.pptx') {
                        let previewUrl = await getPreviewFileUrl(obj);
                        if (previewUrl) {
                            let tempwindow = window.open();
                            tempwindow.location = previewUrl;
                        }
                    } else {
                        this.$message.error('此格式文件不支持预览');
                    }
                } else { // 盖章文件
                    url = `${API_FILE_DOWNLOAD}${obj.nowFilePath}`;
                    // obj.fileName=obj.nowFileName;
                    // obj.filePath=obj.nowFilePath;
                    let index = url.lastIndexOf('.');
                    let fileType = url.substr(index);
                    if (fileType === '.png' || fileType === '.PNG' ||
                        fileType === '.pdf' || fileType === '.PDF' ||
                        fileType === '.JPG' || fileType === '.jpg' ||
                        fileType === '.JPEG' || fileType === '.jpeg' ||
                        fileType === '.BMP' || fileType === '.bmp' ||
                        fileType === '.GIF' || fileType === '.gif' ||
                        fileType === '.TXT' || fileType === '.txt') {
                        let tempwindow = window.open();
                        url = url + '&operationType=2';
                        tempwindow.location = url;
                    } else if (fileType === '.doc' || fileType === '.docx' || fileType === '.xls' || fileType === '.xlsx' || fileType === '.ppt' || fileType === '.pptx') {
                        let previewUrl = await getPreviewFileUrl(obj);
                        if (previewUrl) {
                            let tempwindow = window.open();
                            tempwindow.location = previewUrl;
                        }
                    } else {
                        this.$message.error('此格式文件不支持预览');
                    }
                    // let filePath = obj.primaryFilePath;
                    // let param = {filePath:filePath};
                    // let res = await getSignatureRecord(param);
                    // if(res && res.state=="success"){
                    //     if(res.signList && res.signList.length > 0){
                    //         let fileObj = res.signList[0];
                    //         url = `${API_FILE_DOWNLOAD}${fileObj.nowFilePath}`;
                    //         obj.fileName=fileObj.nowFileName;
                    //         obj.filePath=fileObj.nowFilePath;
                    //         let index= url.lastIndexOf(".");
                    //         let fileType = url.substr(index);
                    //         if(fileType==='.png'||fileType==='.pdf'||fileType==='.PDF'||fileType==='.jpg'||fileType==='.jpeg'||fileType==='.bmp'||fileType==='.gif'||fileType==='.txt'){
                    //             let tempwindow = window.open();
                    //             url=url+'&operationType=2';
                    //             tempwindow.location = url;
                    //         }else if(fileType==='.doc'||fileType==='.docx'||fileType==='.xls'||fileType==='.xlsx'||fileType==='.ppt'||fileType==='.pptx'){
                    //             let previewUrl = await getPreviewFileUrl(obj);
                    //             if (previewUrl) {
                    //                 let tempwindow = window.open();
                    //                 tempwindow.location = previewUrl;
                    //             }
                    //         }else{
                    //             this.$message.error("此格式文件不支持预览");
                    //         }
                    //     }
                    // }
                }
            },
            download (url) {
                downloadFiles(url);
            },
            async downloadFile (obj, type) {
                let url = ``;
                if (type == 1) {
                    url = `${API_FILE_DOWNLOAD}${obj.primaryFilePath}`;
                    this.download(url);
                } else {
                    let filePath = obj.primaryFilePath;
                    let param = {filePath: filePath};
                    let res = await getSignatureRecord(param);
                    if (res && res.state == 'success') {
                        if (res.signList && res.signList.length > 0) {
                            let obj = res.signList[0];
                            let url = `${API_FILE_DOWNLOAD}${obj.nowFilePath}`;
                            this.download(url);
                        }
                    }
                }
            },
            async sealFile (obj) {
                let url = signUrl;
                let param = {};
                if (this.userInfo.userId) {
                    param.formId = obj.formId;
                    param.userId = cloneDeep(this.userInfo.userId);
                    param.tenantId = cloneDeep(this.userInfo.tenantId);
                    param.filePath = obj.primaryFilePath;
                    param.fileByteSize = obj.fileByteSize;
                    param.name = obj.primaryFileName;
                    param.fileName = obj.primaryFileName;
                    param.uid = obj.id;
                    param.createdBy = obj.createPeople;
                    param.processInstanceId = obj.processInstanceId;
                    param.taskId = obj.taskId;
                }
                // 参数存储到redis
                let res = await setSignatureRecordParam(param);
                url += '?param=' + res.signId;
                window.open(url);
            },
            printFile (obj) {

            }
        }
    };
</script>

<style lang="less">
    .signature-record {
        height: 100%;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/signatureFileList/signatureFileRecord.vue